// src/utils/currencyMap.ts

export const currencyMap: Record<string, { symbol: string; code: string }> = {
  US: { symbol: '$', code: 'USD' },
  IN: { symbol: '₹', code: 'INR' },
  GB: { symbol: '£', code: 'GBP' },
  EU: { symbol: '€', code: 'EUR' },
  JP: { symbol: '¥', code: 'JPY' },
  CA: { symbol: 'CA$', code: 'CAD' },
  AU: { symbol: 'A$', code: 'AUD' },
  CN: { symbol: '¥', code: 'CNY' },
  SG: { symbol: 'S$', code: 'SGD' },
  HK: { symbol: 'HK$', code: 'HKD' },
  NZ: { symbol: 'NZ$', code: 'NZD' },
  CH: { symbol: 'CHF', code: 'CHF' },
  AE: { symbol: 'د.إ', code: 'AED' },
  SA: { symbol: '﷼', code: 'SAR' },
  KW: { symbol: 'KD', code: 'KWD' },
  QA: { symbol: 'QR', code: 'QAR' },
  OM: { symbol: '﷼', code: 'OMR' },
  ZA: { symbol: 'R', code: 'ZAR' },
  BR: { symbol: 'R$', code: 'BRL' },
  MX: { symbol: 'MX$', code: 'MXN' },
  RU: { symbol: '₽', code: 'RUB' },
  KR: { symbol: '₩', code: 'KRW' },
  TH: { symbol: '฿', code: 'THB' },
  NL: { symbol: '€', code: 'EUR' },
};
